import { AlertTriangle, CheckCircle2, Clock } from "lucide-react";
import { activeCurrency } from "@/lib/company";

// Tutarı SEÇİLİ sistem para birimiyle biçimlendirir (TL → sonek "1.250,00 ₺"; $/€/£ → önek).
export function fmtCur(v, currency) {
  if (v == null || isNaN(v)) return "—";
  const cur = currency || activeCurrency();
  const n = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v));
  if (!cur || cur === "TRY") return n + " ₺";
  const sym = { USD: "$", EUR: "€", GBP: "£" }[cur] || (cur + " ");
  return sym + n;
}

// Uygulama genelinde para biçimlendirme — seçili para birimini kullanır.
export function fmtTL(v) {
  if (v == null || isNaN(v)) return "—";
  return fmtCur(v, activeCurrency());
}

export function daysLeft(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const now = new Date();
  return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
}

export function ExpiryBadge({ dateStr, testid }) {
  const dl = daysLeft(dateStr);
  if (dl == null) return null;
  let cls = "bg-emerald-50 text-emerald-700 ring-emerald-200";
  let Icon = CheckCircle2;
  if (dl <= 7) { cls = "bg-red-50 text-red-700 ring-red-200"; Icon = AlertTriangle; }
  else if (dl <= 30) { cls = "bg-orange-50 text-orange-700 ring-orange-200"; Icon = Clock; }
  const label = dl < 0 ? `SKT geçti` : `SKT: ${dl} gün`;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${cls}`}>
      <Icon className="h-3 w-3" /> {label}
    </span>
  );
}

export function StockBadge({ qty, unit = "adet", testid }) {
  let cls = "bg-emerald-50 text-emerald-700 ring-emerald-200";
  if (qty <= 0) cls = "bg-red-50 text-red-700 ring-red-200";
  else if (qty <= 30) cls = "bg-orange-50 text-orange-700 ring-orange-200";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[11px] font-semibold tabular ring-1 ring-inset ${cls}`}>
      {qty} {unit}
    </span>
  );
}
